/**
 * Common Panther strings that are used across the site and are not bound to a specific component or page.
 */
export const BACK_BUTTON_LABEL = 'backButton_label';
export const SUBMITTING_ARIA_LABEL = 'submitting_aria_label';
export const CALCULATING_INPUT_LABEL = 'computed_input_calculating_label';
